import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage, type SignInProviderConfig } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';

/*
 * Sign-in page: Microsoft Entra is the only provider in production (auth.providers.microsoft, app registration
 * backstage-sso). The 'guest' entry is offered only when the backend has the guest provider configured
 * (local development / T40 image test), so production builds never show it.
 */
const microsoftProvider: SignInProviderConfig = {
  id: 'microsoft',
  title: 'Microsoft Entra',
  message: 'Sign in with your company Microsoft account',
  apiRef: microsoftAuthApiRef,
};

const CompanySignInPage = (props: any) => {
  const configApi = useApi(configApiRef);
  const guestEnabled = configApi.has('auth.providers.guest');
  const providers: Array<'guest' | SignInProviderConfig> = guestEnabled
    ? ['guest', microsoftProvider]
    : [microsoftProvider];
  return <SignInPage {...props} auto providers={providers} />;
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => CompanySignInPage,
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
